import { FormattedMessage } from "react-intl";
import { Button, Modal } from "react-bootstrap";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../authConfig";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

export const LoginModal = () => {
  const { instance } = useMsal();

  return (
    <Modal show={true} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title className="d-flex">
          <ExclamationTriangleFill className="align-self-center me-2 text-info" />
          <span><FormattedMessage id="component.common.modal.login.title" /></span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage id="component.common.modal.login.description" />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => {
            instance.loginRedirect(loginRequest);
          }}
        >
          <FormattedMessage id="button.login" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
